module.exports = __webpack_public_path__ + "static/media/hots.36613aba.jpg";